module.exports = __webpack_public_path__ + "img/ben.8945ddeb.png";